/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { deletePatientVisit } from "../../actions/patientActions";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";

export const PatientVisitDeleteConfirmModal = ({
  show,
  handleClose,
  id,
  token,
}) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  const deleteVisit = () => {
    setLoading(true);
    dispatch(deletePatientVisit(token, id))
      .then((response) => {
        toast.success("Patient Visit deleted successfully");
        setLoading(false);
        history.push("/dashboard");
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error);
      });
    handleClose();
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className="modal-header">
          <Modal.Title id="contained-modal-title-vcenter">
            Patient Visit Delete Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this patient visit?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="danger" onClick={deleteVisit} disabled={loading}>
            {loading ? "Deleting..." : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
